import { Typography } from "@mui/material";
import { useGetIdentity } from "ra-core";
import { useEffect, useState } from "react";
import AppHeaderTab from "./AppHeaderTab";
import { Division } from "./Division";
const settings = ["Profile", "Account", "Dashboard", "Logout"];

function formatElapsed(seconds: number) {
  const safeSeconds = Math.max(0, seconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const remainSeconds = safeSeconds % 60;

  if (hours > 0) {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(remainSeconds).padStart(2, "0")}`;
  }

  return `${String(minutes).padStart(2, "0")}:${String(remainSeconds).padStart(
    2,
    "0"
  )}`;
}

export const AppBarToolbar = () => {
  const { identity } = useGetIdentity();
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const syncElapsed = () => {
      const lastRefreshAt = Number(
        localStorage.getItem("token_last_refresh_at") || "0"
      );
      if (!lastRefreshAt) {
        setElapsedSeconds(0);
        return;
      }

      const diffSeconds = Math.max(
        0,
        Math.floor((Date.now() - lastRefreshAt) / 1000)
      );
      setElapsedSeconds(diffSeconds);
    };

    syncElapsed();
    const intervalId = window.setInterval(syncElapsed, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const hasRefreshInfo = Boolean(localStorage.getItem("token_last_refresh_at"));

  return (
    <>
      <AppHeaderTab />
      {(identity?.fullName == "banker.8@example.com" ||
        identity?.fullName == "915981876@qq.com" ||
        identity?.fullName == "support@happymangocredit.com") &&
        hasRefreshInfo && (
          <Typography sx={{ mr: 1, fontSize: "0.75rem", color: "#6b7280" }}>
            {/* Last refresh */}
            {formatElapsed(elapsedSeconds)}
          </Typography>
        )}
      <Typography sx={{ mr: 1, fontSize: "0.875rem" }} id="login-user-name">
        {identity?.fullName}
      </Typography>
      <Division />
      {/* hide language select box  */}
      {/* <LocalesMenuButton /> */}
      {/* hide theme select box  */}
      {/* <ThemeSwapper /> */}
      {/* <LoadingIndicator /> */}
    </>
  );
};
